import { InjectionToken, Type } from '@angular/core';
import { WebsocketProvider } from '../interfaces/websocket-provider.interface';

export interface ConnectionData {
  key: string;
  cluster?: string;
  authEndpoint?: string;

  [key: string]: any;
}

export const WEBSOCKET_CONNECTION_DATA = new InjectionToken<ConnectionData>('Connection data for websocket implementation');
export const WEBSOCKET_IMPLEMENTATION_CLASS = new InjectionToken<Type<WebsocketProvider>>('Implementation of the websocket service');
